<template>
    <div
        class="w-full border-b-[6px] bg-ds-primary-50 py-[15px] text-sm font-normal text-ds-primary-600"
        :class="{
            'pl-2': indentationLevel === 0,
            'pl-[18px]': indentationLevel === 1,
            'pl-8': indentationLevel === 2,
        }"
        style="border-bottom: 6px solid white; padding: 15px 9px 15px"
    >
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ indentationLevel?: number }>(), { indentationLevel: 2 });
</script>
